import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-text-type',
  templateUrl: './fb-basic-input-checklist-text-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-text-type.component.css']
})
export class FbCoreBasicInputChecklistTextTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'text',
                placeholder: ''
            };
        }
    }

}
